import React, { useState, useEffect } from "react";
import moment from "moment";

import { useTranslation } from "react-i18next";
import { getCase } from "services/case_service";
import {
  reportCaseComment,
  getCaseCommentsByCase,
} from "services/case_comment_service";
import { getLastParamUrl } from "services/url_utils";

import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import "css/main.css";
import "css/style.css";

import {
  uploadFileToDocument,
  updateDocumentCaseComments,
  createDocument,
} from "services/file_service";

import File from "components/utils/File";
import Topnav from "components/Topnav";

import logoAbilio from "img/mini-abilio-help-icon.svg";
import logoExternal from "img/external-abilio-help-icon.svg";

function Case() {
  const { t } = useTranslation();
  const [caseShow, setCaseShow] = useState({});
  const [caseComment, setCaseComment] = useState([]);
  const [fileName, setFileName] = useState("");
  const [document, setDocument] = useState(null);

  const { register, handleSubmit, resetField } = useForm({});

  useEffect(() => {
    async function getCases() {
      try {
        const caseId = getLastParamUrl();
        const caseBE = await getCase({ getDocUrl: true }, caseId);
        const caseComment = await getComments(caseId);

        setCaseComment(caseComment);
        setCaseShow(caseBE);
      } catch (exception) {
        console.log("exception: ", exception);
      }
    }

    getCases();
  }, []);

  const getComments = async (caseId) => {
    return await getCaseCommentsByCase({ getDocUrl: true }, caseId);
  }

  const changeHandler = async (event) => {
    const doc = await createDocument(null, event.target.files[0].name, null);

    await uploadFileToDocument(doc.id, event.target.files[0]);

    setDocument(doc);
    setFileName(event.target.files[0].name);
  };

  const submitCaseComment = async (data) => {
    data.case = caseShow.id;
    data.account = localStorage.getItem("accountId");
    const casecomm = await reportCaseComment(data);

    if (document) {
      await updateDocumentCaseComments(document.id, casecomm.id);
    }

    const caseCommentList = await getComments(caseShow.id);
    setCaseComment(caseCommentList);
    resetField("body");
  };

  return (
    <div className="geral">
      <Topnav></Topnav>
      <div className="conteudo">
        <div className="conteudo-container">
          <section className="section">
            <nav className="breadcrumb is-footsolution" aria-label="breadcrumbs">
              <ul>
                <li className="">
                  <Link to={"/lista-casos"}>{t("help_center")}</Link>
                </li>
                <li className="is-active">&nbsp;&nbsp;Ticket {caseShow?.id}</li>
              </ul>
            </nav>
            <div className="hero is-footsolution">
              <div className="columns">
                <div className="column is-8">
                  <div className="columns">
                    <div className="column is-10">
                      <h1 className="title is-footsolution">
                        {caseShow?.attributes?.description}
                      </h1>
                    </div>
                    <div className="column">
                      <div className="align-badge">
                        <span className="tag is-rounded is-new is-footsolution is-end">
                          {t(caseShow?.attributes?.status)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="list is-footsolution">
              <div className="columns">
                <div className="column is-8">
                  <div className="box-footsolution">
                    <div className="dialog-client">
                      <div className="columns">
                        <div className="column is-11">
                          <div className="balon">
                            <p>{caseShow?.attributes?.body}</p>
                            <File documentList={caseShow?.attributes?.documents?.data}></File>
                          </div>
                          <div className="sign is-end">
                            <p>
                              <b>{localStorage.getItem("accountName")}</b> .{" "}
                              <data>
                                {moment(caseShow?.attributes?.createdAt).format(
                                  "DD/MM/YYYY HH:MM"
                                )}
                              </data>
                            </p>
                          </div>
                        </div>

                        <div className="column is-1">
                          <img alt="chatbox-helper-footsolution" className="user-image is-end" src={logoAbilio} />
                        </div>
                      </div>
                    </div>

                    {/* Important: comments without account means they are from footsolution internal users and are rendered as so   */}
                    {caseComment.map((el, idx) =>
                      !el?.attributes?.account?.data?.id ? (
                        <div key={idx} className="dialog-footsolution">
                          <div className="columns">
                            <div className="column is-1">
                              <img alt="chatbox-helper-external" className="user-image" src={logoExternal} />
                            </div>

                            <div className="column is-11">
                              <div className="balon">
                                <p>{el.attributes.body}</p>
                                  <File documentList={el?.attributes?.documents?.data}></File>
                              </div>
                              <div className="sign">
                                <p>
                                  <b>Apoio ao cliente</b> .{" "}
                                  <data>
                                    {moment(el?.attributes?.createdAt).format(
                                      "DD/MM/YYYY HH:MM"
                                    )}
                                  </data>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div key={idx} className="dialog-client">
                          <div className="columns">
                            <div className="column is-11">
                              <div className="balon">
                                <p>{el?.attributes?.body}</p>
                                <File documentList={el?.attributes?.documents?.data}></File>
                              </div>
                              <div className="sign is-end">
                                <p>
                                  <b>{localStorage.getItem("accountName")}</b> .{" "}
                                  <data>
                                    {moment(el?.attributes?.createdAt).format(
                                      "DD/MM/YYYY HH:MM"
                                    )}
                                  </data>
                                </p>
                              </div>
                            </div>

                            <div className="column is-1">
                              <img
                                alt="chatbox-helper-footsolution"
                                className="user-image is-end"
                                src={logoAbilio}
                              />
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>

                  <div className="box-footsolution">
                    <form
                      onSubmit={handleSubmit((data) => submitCaseComment(data))}
                    >
                      <div className="body-form control">
                        <div className="body-messagem show-ticket">
                          <textarea
                            {...register("body", {
                              required: true,
                              minLength: 5,
                            })}
                            className="textarea is-footsolution"
                            placeholder={t("write_answer")}
                            rows="5"
                          ></textarea>
                        </div>

                        <div className="anexos">
                          <ul>
                            {document && (
                              <li>
                                <span className="icon">
                                  <i className="fa fa-paperclip"></i>
                                </span>{" "}
                                {fileName}
                              </li>
                            )}
                          </ul>
                        </div>

                        <div className="buttons is-right">
                          <button className="button is-footsolution">
                            <input
                              className="file-input"
                              type="file"
                              name="resume"
                              onChange={(event) => changeHandler(event)}
                            />
                            <span className="icon" style={{ margin: 0 }}>
                              <i className="fa fa-paperclip"></i>
                            </span>
                          </button>
                          <button className="button is-link is-footsolution">
                            {t("send")}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="column">
                  <div className="box-footsolution extra">
                    <h2 className="subtitle is-footsolution">
                      {t("helper_details")}
                    </h2>
                    <div className="container-counter">
                      <div className="columns">
                        <div className="column is-2">
                          <img
                            alt="chatbox-external"
                            className="user-image"
                            style={{ width: "50px", height: "50px" }}
                            src={logoExternal}
                          />
                        </div>
                        <div className="column">
                          <p>
                            <b>Apoio ao cliente</b>
                          </p>
                          <p style={{ fontSize: "14px" }}>
                            {t("customer_support")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Case;
